import { all, call, put, takeLatest } from "redux-saga/effects";

import { getDetailRRFailed, getDetailRRStart, getDetailRRSuccess } from "../redux/getResearchReportDetail";
import { getDetailReseachReportApi } from "core/http/service/researchReport";

function* getDetailResearchReportWork(action) {
    const payload = action.payload
  try {
    const res = yield call(getDetailReseachReportApi, payload.nodeId);
    yield put({
      type: getDetailRRSuccess.type,
      payload: {
        data: res,
      },
    });
  } catch (error: any) {
    yield put({
      type: getDetailRRFailed.type,
    });
  }
}
function* watchGetDetailResearchReport() {
  yield takeLatest(getDetailRRStart.type, getDetailResearchReportWork);
}

export default function* getDetailResearchReportSaga() {
  yield all([watchGetDetailResearchReport()]);
}
